var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappySchedule = function SvgHappySchedule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "m8.867 9.8.933-.933L7.333 6.4V3.333H6v3.6zm-2.2 3.533a6.5 6.5 0 0 1-2.6-.525 6.7 6.7 0 0 1-2.117-1.425A6.7 6.7 0 0 1 .525 9.267 6.5 6.5 0 0 1 0 6.667q0-1.385.525-2.6A6.7 6.7 0 0 1 1.95 1.95q.9-.9 2.117-1.425A6.5 6.5 0 0 1 6.667 0q1.383 0 2.6.525 1.216.525 2.116 1.425t1.425 2.117q.525 1.215.525 2.6 0 1.383-.525 2.6a6.7 6.7 0 0 1-1.425 2.116q-.9.9-2.116 1.425a6.5 6.5 0 0 1-2.6.525m0-1.333q2.216 0 3.775-1.558Q12 8.882 12 6.667q0-2.217-1.558-3.775-1.56-1.56-3.775-1.559-2.217 0-3.775 1.559-1.56 1.558-1.559 3.775 0 2.216 1.559 3.775T6.667 12"
  })));
};
export default SvgHappySchedule;